interface JobSubTitleProps {
  locationName: string;
  locationCountry?: string;
  isRemote?: boolean;
}

const JobSubTitle = ({
  locationName,
  locationCountry,
  isRemote,
}: JobSubTitleProps) => {
  return (
    <>
      {locationName}
      {!locationName.toLowerCase().includes('remote') && (
        <>
          {isRemote && locationName && ' or '}
          {isRemote && 'Remote'}
        </>
      )}
      {isRemote &&
        !locationName.includes('US') &&
        locationCountry === 'USA' &&
        ' (US)'}
      {isRemote &&
        !locationName.includes('UK') &&
        locationCountry === 'UK' &&
        ' (UK)'}
    </>
  );
};

export { JobSubTitle };
